import React from 'react';

function MappingActionContainer(props) {
    return (
        <div style={{ display: "flex" }}>
            {props.children}
        </div>
    );
}

export default MappingActionContainer;
